const ErrorMessage = Object.freeze({
  ECONNABORTED: 'Request bị timeout',
  ERR_NETWORK: 'Lỗi kết nối mạng',
  ERR_BAD_REQUEST: 'Dữ liệu request không hợp lệ',
  ERR_BAD_RESPONSE: 'Response không hợp lệ',
  ERR_FR_TOO_MANY_REDIRECTS: 'Quá nhiều redirect',
  ERR_CANCELED: 'Request bị hủy',
  ERR_INVALID_URL: 'URL không hợp lệ',
})

export class AxiosError {
  constructor({ code, message = '' }) {
    return {
      error: true,
      message: message || ErrorMessage[code] || 'Lỗi không xác định',
      code,
    }
  }
}
